<template lang="pug">
.search-criteria-wrapper.filter-item-wrapper
    input.search-criteria(
        :value='query',
        :placeholder='placeholder',
        @input='handleQueryChange($event.target.value)',
        @keyup.delete='resetSearch()',
        @keyup.enter='launchSearch()'
    )
    svg-icon.search-reset(v-if='query', name='close', size='small', @click.native='resetSearch(true)')
    .search-filter
        | Filter on :
        select.search-targets(:value='queryType', @change='handleQueryTypeChange($event.target.value)')
            option(v-if='allTypeSearch', :value='null', label='all')
            option(v-for='(typeLabel, typeValue) in types', :value='typeValue', :key='typeValue', :label='typeLabel')
</template>

<script>
import { filterByQuery } from '@/utils/filters'
import { parseFilterParams } from '@/utils/helpers'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
    name: 'Search',

    props: {
        query: {
            required: false,
            default: '',
            type: String
        },
        queryType: {
            required: false,
            default: null,
            type: String
        },
        types: {
            type: Object,
            default: () => ({})
        },
        allTypeSearch: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: 'Search item'
        },
        sortByScore: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapState('ui/monitoring', { 
            selectedAudienceId: state => state.selectedRowId,
            selectedRowFrom: state => state.selectedRowFrom
        }),
        ...mapGetters('data/audience', ['getItemById']),
        filterMethod() {
            return data => {
                if (this.query === '' || this.query === null) return data
                const keys = this.queryType === null ? Object.keys(this.types) : [this.queryType]
                const result = filterByQuery(data, this.query, keys)
                return this.formateResult(result)
            }
        },
        audienceInfoDetail() {
            const audienceInDetail = this.getItemById({ id: this.selectedAudienceId })
            // @TODO error notificationselectedAudienceHaveDeletedCriteria
            return audienceInDetail == false ? null : audienceInDetail
        },
    },

    watch: {
        query: {
            handler(value) {
                this.handleQueryChange(value, true)
            },
            immediate: true
        },
        queryType: {
            handler(value) {
                this.handleQueryTypeChange(value, true)
            },
            immediate: true
        }
    },

    methods: {
        ...mapMutations('ui/monitoring', ['setSelectedRow']),
        handleQueryChange(value, force = false) {
            if(this.selectedRowFrom === 'other-page'){
                this.setSelectedRow({rowId: this.selectedAudienceId})
                return
            }
            value = parseFilterParams(value)
            if (this.query != value || force) {
                if(this.audienceInfoDetail) this.setSelectedRow({ rowId: null })
                this.$emit('queryChange', value)
            }
        },

        handleQueryTypeChange(value, force = false) {
            value = parseFilterParams(value)
            if (this.queryType != value || force) {
                this.$emit('queryTypeChange', value)
                this.launchSearch()
            }
        },

        launchSearch() {
            const sortByScore = this.query !== '' && this.query !== null && this.sortByScore
            this.$emit('filterChange', { fn: this.filterMethod, sortByScore })
        },

        resetSearch(force) {
            if (this.query === null || force) {
                this.$emit('reset')
                this.$emit('queryChange', null)
            }
        },

        formateResult(result) {
            return result.map(({ item, score, matches }) => ({
                ...item,
                score,
                ...this.getMatchesString(matches)
            }))
        },

        getMatchesString(matches) {
            return matches.reduce((result, { indices, key, value }) => {
                const newKey = `${key}WithMatchHighlight`
                result[newKey] = this.generateHighlightedText(value, indices)
                return result
            }, {})
        },

        generateHighlightedText(text, indices) {
            let content = ''
            let nextUnhighlightedIndiceStartingIndex = 0

            indices.forEach(([start, end]) => {
                const lastIndiceNextIndex = end + 1
                content += [
                    text.substring(nextUnhighlightedIndiceStartingIndex, start),
                    '<span class="highlight">',
                    text.substring(start, lastIndiceNextIndex),
                    '</span>'
                ].join('')
                nextUnhighlightedIndiceStartingIndex = lastIndiceNextIndex
                return content
            })

            content += text.substring(nextUnhighlightedIndiceStartingIndex)
            return content
        }
    }
}
</script>
